import{CHROMECAST_HANDLER_ID as r}from"../constants";export var isChromecastHandler=function(t){return t.getId()===r};